// extracted by mini-css-extract-plugin
export default {"filterPill":"_27c2b___FilterPill-module__filterPill","label":"_2XAqY___FilterPill-module__label","close":"_2CjRL___FilterPill-module__close"};